import { useLocation, useNavigate } from 'react-router';

import { useProject } from '../projects/context';
import { usePhone } from '../telephony/phoneContext';

// Eingehender Rückruf eines Kunden: klingelt überall in der App. „Annehmen“ öffnet den passenden Lead mit dem
// laufenden Gespräch in der Akquise, bei unbekannter Nummer die Leadsuche mit der Nummer.
export function IncomingCallBanner() {
  const phone = usePhone();
  const navigate = useNavigate();
  const { project } = useProject();
  const incoming = phone.incoming;
  if (phone.state !== 'incoming' || !incoming) return null;
  const accept = () => {
    const info = phone.accept();
    if (!info) return;
    const base = `/p/${project.key}`;
    navigate(info.leadId ? `${base}/akquise/${info.leadId}?anruf=${info.callId}` : `${base}/leads?q=${encodeURIComponent(info.caller)}`);
  };
  return (
    <div className="incoming-call" role="alertdialog" aria-label="Eingehender Anruf" aria-live="assertive">
      <span className="incoming-call-pulse" aria-hidden="true" />
      <div className="incoming-call-text">
        <strong>Eingehender Anruf</strong>
        <span>{incoming.leadName ?? 'Unbekannte Nummer'}</span>
        <span className="muted">{incoming.caller}</span>
      </div>
      <button type="button" className="btn btn-primary" onClick={accept}>
        Annehmen
      </button>
      <button type="button" className="btn btn-ghost" onClick={phone.reject}>
        Ablehnen
      </button>
    </div>
  );
}

// Laufendes Browser-Gespräch außerhalb der Akquise (z. B. unbekannter Anrufer, andere Seite geöffnet).
export function ActiveCallBar() {
  const phone = usePhone();
  const { pathname } = useLocation();
  if (phone.state !== 'in-call' || pathname.includes('/akquise')) return null;
  return (
    <div className="active-call-bar" role="status">
      <span className="call-dot" aria-hidden="true" />
      <strong>Im Gespräch</strong>
      <button type="button" className="btn btn-small" aria-pressed={phone.muted} onClick={phone.toggleMute}>
        {phone.muted ? 'Mikrofon an' : 'Stumm'}
      </button>
      <button type="button" className="btn btn-danger btn-small" onClick={phone.hangup}>
        Auflegen
      </button>
    </div>
  );
}
